import { DMEPOS_ACCOUNT_TYPE_ENUM } from '@core/enums/dmepos-account-type.enum';

export const DmeposAccountTypesValue = [
    DMEPOS_ACCOUNT_TYPE_ENUM.DMEPOS_PROVIDER
];
